import {  useEffect, useState } from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

// firstname|lastname|activation|created_at
const sortingOptions = [
  { value: 'created_at.desc', label: 'Newest Added' },
  { value: 'created_at.asc', label: 'Latest Added' },
  { value: 'useraccesslevel.desc', label: 'Admin First' },
  { value: 'firstname.asc', label: 'First Name A to Z' },
  { value: 'firstname.desc', label: 'First Name Z to A' },
  { value: 'lastname.asc', label: 'Last Name A to Z' },
  { value: 'lastname.desc', label: 'Last Name Z to A' },
]

interface IProps {
  value: string
  onChange: (value: string) => void
}

export default function UserSorting({ value, onChange }: IProps) {
  const [maxHeight, setMaxHeight] = useState<number>(400)

  // Tính toán maxHeight dựa trên kích thước màn hình
  useEffect(() => {
    const calculateMaxHeight = () => {
      const windowHeight = window.innerHeight
      const maxContentHeight = windowHeight * 0.7 // 70% chiều cao màn hình
      setMaxHeight(maxContentHeight)
    }

    calculateMaxHeight()
    window.addEventListener('resize', calculateMaxHeight)

    return () => {
      window.removeEventListener('resize', calculateMaxHeight)
    }
  }, [])

  return (
    <div className="h-[38px] border border-[#D5D5D5] rounded-[10px] md:rounded-l-[0px] !md:rounded-r-[10px] md:-ml-[1px]">
      <Select
        value={value}
        onValueChange={onChange}
        defaultValue="created_at.desc"
      >
        <SelectTrigger className="w-full h-full justify-start border-none !shadow-none !ring-0">
          <div className="flex flex-row gap-1 w-full">
            <p>Sort:</p>
            <SelectValue placeholder="Sort by" />
          </div>
        </SelectTrigger>
        <SelectContent
          style={{ maxHeight: `${maxHeight}px` }}
          className="pt-1]"
        >
          <div className="py-1 pb-2">
            {sortingOptions.map((option, index) => (
              <SelectItem
                firstItem={index === 0}
                lastItem={index === sortingOptions.length - 1}
                key={option.value}
                value={option.value}
                className="hover:bg-gray-100 rounded-md "
                enableSeparator={index !== sortingOptions.length - 1}
              >
                {option.label}
              </SelectItem>
            ))}
          </div>
        </SelectContent>
      </Select>
    </div>
  )
}
